import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetBillingStatusV2Response } from './get-billing-status-v2-response';
import { getBillingStatusV2ResponseSchema } from './get-billing-status-v2-response';

export async function getBillingStatusV2Api(): Promise<
  IValidatedResponse<IGetBillingStatusV2Response>
> {
  return getRequest<IGetBillingStatusV2Response>({
    path: '/billing/v2',
    schema: getBillingStatusV2ResponseSchema,
  });
}
